import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Card, Button, Spinner, Modal, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import useCaseDetailsContext from "../../hooks/useCaseDetailsContext";
import FormInput from "../FormInput";
import { logout } from "../../redux/actions/AuthActions";
import { toast } from "react-toastify";
import Select from "react-dropdown-select";
import swal from 'sweetalert2';
import { getMasterBackendOfficerList } from "../../redux/actions/MasterActions";
import Preloader from "../Preloader";
import "react-datepicker/dist/react-datepicker.css";
import '../../styles/common.css'

const API_KEY = "AIzaSyD5L3M2Nl4wn3coWVJlI06RjT50l44FMu8";

const AddCaseGenerateInitialReport = ({ show, onHide, editId }) => {
  const { id } = useParams();
  const caseCtx = useCaseDetailsContext();
  const {
    pathname,
    actions,
    caseDetailsLists,
    loadingCaseDetails,
    errorsCaseDetails,
    changedCaseDetailsStatus,
    resetStatusType,
  } = caseCtx;
  const { t } = useTranslation();
  const [showModel, setShowModel] = useState(null);
  const [stateId, setStateId] = useState(null);
  const [placeData, setPlaceData] = useState({});
  const [formData, setFormData] = useState({});
  const dispatch = useDispatch();
  const {
    AuthReducer: { auth, loading, errors },
    masterReducer: {
      masterBackendLists,
      loadingMaster,
      errorsMaster,
    },
  } = useSelector((state) => state);

  useEffect(() => {
    if (show && auth?.token)
    {
      dispatch(getMasterBackendOfficerList(auth?.token, id));
    }
  }, [show, auth?.token, dispatch]);

  const [validated, setValidated] = useState(false);
  

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    setValidated(true);

    const updatedFormData = {
      ...formData,
      case_id: id
    };

    if(id)
    {
      dispatch(actions.saveAssignBackendOfficer(auth?.token, updatedFormData));
    }
  };

  useEffect(() => {
    if(id)
    {
      dispatch(actions.fetchCaseDetailsById(auth?.token, id, pathname));
    }
  }, [auth, id, pathname, dispatch, actions]);

  
  useEffect(() => {
    if(editId && caseDetailsLists && Object.keys(caseDetailsLists).length > 0) {
      setFormData({
      });
    }
  }, [caseDetailsLists]);

  useEffect(() => {
    if (errors && Object.keys(errors).length > 0 && errors?.status === 401) {
      dispatch(logout());
      toast.error(errors?.data?.message);
      onHide();
    }
  }, [errors, dispatch, onHide]);

  const selectHandler2 = (selectedData, name) => {
    setFormData(prevFormData => ({
      ...prevFormData,
      [name]: selectedData
    }));
  };

  const customSelectStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: errorsCaseDetails?.data?.vehicle_model ? 'red' : base.borderColor,
      '&:hover': {
        borderColor: errorsCaseDetails?.data?.vehicle_model ? 'red' : base.borderColor,
      }
    }),
  };

  const inputHandler = (e) => {
    const { value, name } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  
  useEffect(() => {
    if (changedCaseDetailsStatus?.success) {
    onHide()
      swal.fire({
        show: true,
        title: "Well done!",
        text: changedCaseDetailsStatus?.message,
        icon: "success",
        showConfirmButton: false,
        timer: 1500
      });
      dispatch({ type: resetStatusType });
    }
  }, [changedCaseDetailsStatus, dispatch, resetStatusType]);


  return (
    <Modal show={show} onHide={onHide} size="md" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>{t("Generate Initial Report")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {errorsCaseDetails?.data?.message && (
          <div className="alert alert-danger">
            {errorsCaseDetails?.data?.message}
          </div>
        )}
        <Row>
          <Col lg={12}>
            <Card>
              <Card.Body>
                <Form.Group className="mb-3">
                  <Form.Label>{t("Doctor")}</Form.Label>
                  <Select
                    options={masterBackendLists?.map(user => ({
                      ...user,
                      customLabel: `${user.name} ( ${user?.adminUserType?.name} ) - ${user?.citiesAdminUsers?.city_name}, ${user?.citiesAdminUsers?.cities_state?.state_name} | Alloc: ${user?.allocationCount} | Att: ${user?.todayAttendance}`
                    }))}
                    values={masterBackendLists?.filter(user => user?.id === formData?.bofficer_id)?.map(user => ({
                      ...user,
                      customLabel: `${user.name} ( ${user?.adminUserType?.name} ) - ${user?.citiesAdminUsers?.city_name}, ${user?.citiesAdminUsers?.cities_state?.state_name} | Alloc: ${user?.allocationCount} | Att: ${user?.todayAttendance}`
                    }))}
                    name="bofficer_id"
                    labelField="customLabel"
                    valueField="id"
                    searchBy="name"
                    placeholder={t("Select Investigator")}
                    loading={loadingMaster}
                    onChange={(selectedData) => {
                      if (selectedData.length > 0) {
                        selectHandler2(selectedData[0]?.id, "bofficer_id");
                      }
                    }}
                    itemRenderer={({ item, itemIndex, props, state, methods }) => (
                      <div 
                        onClick={() => methods.addItem(item)}
                        style={{
                          padding: '10px',
                          cursor: 'pointer',
                          borderBottom: '1px solid #eee',
                          backgroundColor: state.values.find(val => val.id === item.id) ? '#e3f2fd' : 'white'
                        }}
                      >
                        <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>
                          {item.name} <span style={{ color: '#666', fontSize: '0.9em' }}>({item?.adminUserType?.name})</span>
                        </div>
                        <div style={{ fontSize: '0.85em', color: '#555', marginBottom: '3px' }}>
                          {item?.citiesAdminUsers?.city_name}, {item?.citiesAdminUsers?.cities_state?.state_name}
                        </div>
                        <div style={{ display: 'flex', gap: '15px', fontSize: '0.8em', marginTop: '5px' }}>
                          <span style={{ color: '#FF9800' }}>
                            <strong>Alloc:</strong> {item?.allocationCount}
                          </span>
                          <span style={{ 
                            color: item?.todayAttendance === 'Present' ? '#4CAF50' : item?.todayAttendance === 'Not Working' ? '#F44336' : '#666',
                            fontWeight: '500'
                          }}>
                            <strong>Att:</strong> {item?.todayAttendance}
                          </span>
                        </div>
                      </div>
                    )}
                    styles={customSelectStyles}
                  />

                  {errorsCaseDetails?.data?.bofficer_id && (
                    <div className="invalid-feedback d-block">
                      <p className="text-danger">{errorsCaseDetails?.data?.bofficer_id}</p>
                    </div>
                  )}
                </Form.Group>

                <FormInput
                  label={t("Remark")}
                  type="text"
                  placeholder={t("Enter Remarks")}
                  errors={errorsCaseDetails?.data}
                  value={formData.remark}
                  name="remark"
                  onChange={inputHandler}
                  containerClass={"mb-3"}
                />
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <div className="d-flex justify-content-center">
          {loading ? 
            <Button color="primary" disabled>
              <Spinner animation="border" size="sm" />
              {t("Please wait ...")}
            </Button>
          :
            <Button type="button" onClick={(e) => handleSubmit(e)} disabled={loading}>
              {t("Generate")}
            </Button>
          }
        </div>
      </Modal.Body>
      {loadingCaseDetails && <Preloader />}
    </Modal>
  );
};

export default AddCaseGenerateInitialReport;
